// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';

import * as mixins from '@helpcenter/styles/src/mixins';
import { LinkCard } from 'view/common/card';
import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { token } from '@atlaskit/tokens';

const HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const isHcAdsDropCommit2Enabled = (): boolean => FeatureGates.checkGate(HC_ADS_DROP_COMMIT_2);

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const IconContainer = styled.div`
	margin-right: ${token('space.100', '8px')};
`;

export type Appearance = 'white' | 'gray';

interface CardProps {
	appearance?: Appearance;
	padding?: number;
}

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const Card = styled(LinkCard)<CardProps>`
	${mixins.borderRadius};
	${() => isHcAdsDropCommit2Enabled() && mixins.borderRadiusLarge}
	/* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
	background: ${(props) =>
		props.appearance === 'gray'
			? token('elevation.surface.raised', '#FAFBFC')
			: token('elevation.surface.raised', '#FFFFFF')};
	/* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
	padding: ${(props) =>
		props.padding !== undefined ? `${props.padding}px` : token('space.200', '16px')};

	span {
		color: ${token('color.text', '#172B4D')};
	}
	&:hover {
		/* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
		background: ${(props) =>
			props.appearance === 'gray'
				? token('elevation.surface.raised.hovered', '#FAFBFC')
				: token('elevation.surface.raised.hovered', '#FFFFFF')};
	}
`;
